import { render } from "./PersonalizedPopupThanks.vue?vue&type=template&id=f1caa8aa"
import script from "./PersonalizedPopupThanks.vue?vue&type=script&lang=js"
export * from "./PersonalizedPopupThanks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__